module.exports = __webpack_public_path__ + "media/icons/cuk_mail@2x-0f4a90e9.png";